<template>
	<svg
		fill="none"
		height="89"
		version="1.1"
		viewBox="0 0 89.105095 89"
		width="89.105095">
		<circle
			cx="14"
			cy="14"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<circle
			cx="14"
			cy="44"
			r="11.5"
			stroke="#000000"
			stroke-width="5" />
		<rect
			fill="#000000"
			height="6"
			transform="rotate(30)"
			width="44"
			x="30.91856"
			y="1.5525182" />
		<circle
			cx="-75.105003"
			cy="14"
			r="11.5"
			stroke="#000000"
			stroke-width="5"
			transform="scale(-1,1)" />
		<circle
			cx="-75.105003"
			cy="44"
			r="11.5"
			stroke="#000000"
			stroke-width="5"
			transform="scale(-1,1)" />
		<rect
			fill="#000000"
			height="5.9999981"
			transform="matrix(-0.8660253,0.50000017,0.50000017,0.8660253,0,0)"
			width="43.999985"
			x="-46.248711"
			y="46.105076" />
		<circle
			cx="14"
			cy="-75"
			r="11.5"
			stroke="#000000"
			stroke-width="5"
			transform="scale(1,-1)" />
		<rect
			fill="#000000"
			height="5.9999981"
			transform="matrix(0.8660253,-0.50000017,-0.50000017,-0.8660253,0,0)"
			width="43.999985"
			x="-14.081455"
			y="-76.389763" />
		<circle
			cx="-75.105095"
			cy="-75"
			r="11.5"
			stroke="#000000"
			stroke-width="5"
			transform="scale(-1)" />
		<rect
			fill="#000000"
			height="6"
			transform="rotate(-150)"
			width="44"
			x="-91.248718"
			y="-31.837221" />
		<rect
			fill="#000000"
			height="6"
			width="41"
			x="23"
			y="42" />
	</svg>
</template>
